import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatChatting = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3666 12.4786L12.5268 12.5614C13.0349 12.5977 13.289 12.6159 13.479 12.5258C13.6458 12.4467 13.7801 12.3124 13.8591 12.1456C13.9492 11.9557 13.9311 11.7016 13.8948 11.1935L13.8119 10.0333C13.7986 9.847 13.7919 9.75385 13.7906 9.65881C13.7881 9.48673 13.786 9.57733 13.7966 9.40556C13.8025 9.31069 13.8557 8.86437 13.9622 7.97179C13.9872 7.76245 14 7.54939 14 7.33333C14 4.38781 11.6122 2 8.66667 2C6.83355 2 5.21644 2.92482 4.25645 4.33333M9.2 10.4C9.2 8.41174 7.58822 6.79997 5.6 6.79997C4.74393 6.79997 3.95766 7.09877 3.33978 7.59778C3.29519 7.63378 3.25148 7.67083 3.20869 7.70889C2.46715 8.3683 2 9.32958 2 10.4C2 10.5942 2.01538 10.7848 2.04498 10.9707C2.10863 11.3703 2.14046 11.5701 2.14597 11.6318C2.15425 11.7243 2.15335 11.7037 2.15312 11.7966C2.15296 11.8585 2.14765 11.9329 2.13702 12.0817L2.07103 13.0056C2.04653 13.3486 2.03428 13.52 2.09508 13.6483C2.14845 13.7609 2.23911 13.8515 2.35169 13.9049C2.47993 13.9657 2.65142 13.9534 2.99439 13.9289L3.91827 13.8629C4.06705 13.8523 4.14144 13.847 4.20336 13.8468C4.2963 13.8466 4.27565 13.8457 4.36821 13.854C4.42988 13.8595 4.62981 13.8914 5.0293 13.955C5.21517 13.9846 5.40579 14 5.6 14C6.67039 14 7.63166 13.5328 8.29108 12.7913C8.32913 12.7485 8.36617 12.7048 8.40217 12.6602C8.90119 12.0423 9.2 11.256 9.2 10.4Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgChatChatting);
export default ForwardRef;
